import MeasuredValueDTO from "features/shared/dtos/MeasuredValueDTO";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import NumberFormatter from "features/shared/components/formatters/NumberFormatter";
import React from "react";
import { formatDate } from "features/shared/helpers/Formatters";
import { useTranslation } from "react-i18next";

type Props = {
  planConsumption: MeasuredValueDTO;
  realConsumption: MeasuredValueDTO;
  isProduction?: boolean;
};

const PlaceOfDeliveryMonthConsumption = ({
  planConsumption,
  realConsumption,
  isProduction,
}: Props) => {
  // translations
  const { i18n } = useTranslation();

  // sub-renders
  const renderPlanConsumption = () => {
    if (isProduction) {
      return <>-</>;
    } else {
      return (
        <NumberFormatter amount={planConsumption.value!} decimalPlaces={3} />
      );
    }
  };

  const getConsumptionMonth = () => {
    return formatDate(planConsumption.from!, { month: "long" }, i18n.language);
  };

  // render
  return (
    <div className="row no-gutters">
      <div className="col">
        {getConsumptionMonth()}
      </div>
      <div className="col text-center">{renderPlanConsumption()}</div>
      <div className="col text-center">
        <NumberFormatter amount={realConsumption.value!} decimalPlaces={3} />
      </div>
    </div>
  );
};

export default PlaceOfDeliveryMonthConsumption;